var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"relative flex mx-6 cursor-pointer",on:{"click":_vm.handleShowNotificationDrawer}},[_c('notification-icon',{staticClass:"h-8"}),(_vm.unReadNotificationsCount > 0)?_c('div',{staticClass:"ntn_btn text-center"},[_vm._v(" "+_vm._s(_vm.unReadNotificationsCount)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }